// extracted by mini-css-extract-plugin
var _1 = "Group_fluid__c420e";
var _2 = "Group_isGap__95c05";
var _3 = "Group_join__3e0bd";
var _4 = "Group_root__7e7bf";
var _5 = "Group_vertical__a7c1b";
export { _1 as "fluid", _2 as "isGap", _3 as "join", _4 as "root", _5 as "vertical" }
